function dm_vimeo_modal(){

    let currentTrigger = null;

    document.querySelectorAll('.video-trigger').forEach(trigger => {
        trigger.addEventListener('click', function () {
            currentTrigger = this;
        });
    });

    const modal = document.getElementById('videoModal');
    const modalBody = modal.querySelector('.modal-body');

    modal.addEventListener('shown.bs.modal', function () {
        if (currentTrigger) {
            const vimeoId = currentTrigger.getAttribute('data-dm-vimeo-id');

            if (vimeoId) {
                const iframe = `<iframe src="https://player.vimeo.com/video/${vimeoId}?autoplay=1&controls=1&loop=0&autopause=0&title=0&portrait=0&byline=0&vimeo_logo=0&colors=1E1E1E,E10A0A,FAF3F0,D20202" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
                modalBody.innerHTML = iframe;
            }
        }
    });

    modal.addEventListener('hidden.bs.modal', function () {
        modalBody.innerHTML = '';
        currentTrigger = null;
    });

}

export {dm_vimeo_modal};